import request from "../../untils/request.js"


//分页
export const getSqbmanageList = (params) => {
    return request.get('/outpatient/sqbmanage/page',{params})
}
//新增
export const addSqbUserKeys = (data) => {
    return request.post('/outpatient/sqbmanage',data)
}
//修改
export const editSqbUserKeys = (data) => {
    return request.put('/outpatient/sqbmanage',data)
}

//激活
export const activateSqbUserKeys = (params) => {
    return request.get('/outpatient/sqbmanage/activate', {params})
}
//签到
export const signInSqbUserKeys = (params) => {
    return request.get('/outpatient/sqbmanage/checkin', {params})
}

export default{
}

